// Outlook notification banner utility
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function showWorkbenchNotificationBanner(item, workbenchId, DebugService) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!item || !workbenchId) {
            DebugService.warn('Cannot show notification banner: missing item or workbenchId');
            return;
        }
        DebugService.debug('Showing Outlook notification banner with WBID:', workbenchId);
        return new Promise((resolve) => {
            // Check if notificationMessages API is available
            if (!item.notificationMessages || typeof item.notificationMessages.replaceAsync !== 'function') {
                DebugService.warn('notificationMessages API not available on this item');
                resolve();
                return;
            }
            // Use the exact format provided by the user
            item.notificationMessages.replaceAsync("workbenchSubmissionBanner", // Unique key for this message
            {
                type: "informationalMessage",
                message: `This email has been successfully submitted for ingestion with Placement ID: ${workbenchId}`,
                icon: "Icon.16x16", // Icon from manifest assets
                persistent: true // If true, stays until dismissed
            }, function (asyncResult) {
                var _a;
                if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                    DebugService.debug('Banner displayed successfully!');
                }
                else {
                    DebugService.error('Failed to display banner:', (_a = asyncResult.error) === null || _a === void 0 ? void 0 : _a.message);
                }
                resolve();
            });
        });
    });
}
